import { useEffect } from "react";
import toast from "react-hot-toast";

interface UseConnectionToastsArgs {
  isCalendarAuthExpired: boolean;
  connectGoogleCalendar: () => void;
  gmailReconnectNeeded: string[];
  connectGmail: () => void;
}

export function useConnectionToasts({
  isCalendarAuthExpired,
  connectGoogleCalendar,
  gmailReconnectNeeded,
  connectGmail,
}: UseConnectionToastsArgs): void {
  useEffect(() => {
    if (!isCalendarAuthExpired) return;
    toast(
      (t) => (
        <span>
          Google Calendar connection expired.{" "}
          <button
            onClick={() => {
              connectGoogleCalendar();
              toast.dismiss(t.id);
            }}
            style={{
              fontWeight: 600,
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Reconnect
          </button>
        </span>
      ),
      { duration: Infinity, id: "gcal-auth-expired" },
    );
  }, [isCalendarAuthExpired, connectGoogleCalendar]);

  // Surface a one-time reconnect prompt per Gmail account whose Google grant
  // expired/was revoked (refresh returned GMAIL_TOKEN_EXPIRED). Keyed by
  // email so repeated background refreshes update the same toast rather than
  // stacking new ones.
  useEffect(() => {
    gmailReconnectNeeded.forEach((email) => {
      toast(
        (t) => (
          <span>
            Gmail connection for {email} expired.{" "}
            <button
              onClick={() => {
                connectGmail();
                toast.dismiss(t.id);
              }}
              style={{
                fontWeight: 600,
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Reconnect
            </button>
          </span>
        ),
        { duration: Infinity, id: `gmail-auth-expired-${email}` },
      );
    });
  }, [gmailReconnectNeeded, connectGmail]);
}
